import React from "react";
import { ScheduleComparison } from "../../../models/ScheduleComparison";
import "./Scorecard.scss";

export default function ComparisonHistoryList({
  comparisons, selectedId, onSelect,
}: { comparisons: ScheduleComparison[]; selectedId?: string; onSelect: (c: ScheduleComparison) => void }) {
  if (comparisons.length === 0) return null;
  return (
    <ul className="scorecard-history">
      {comparisons.map((c) => (
        <li key={c.id} className={c.id === selectedId ? "selected" : ""} onClick={() => onSelect(c)}>
          <span className="when">{new Date(c.createdAt).toLocaleString()}</span>
          <span className="cost-delta">{c.deltas.costTotal > 0 ? "+" : ""}${c.deltas.costTotal.toFixed(2)}</span>
          <span className={`badge ${c.comparable ? "ok" : "warn"}`}>{c.comparable ? "comparable" : "not comparable"}</span>
        </li>
      ))}
    </ul>
  );
}
